import { render, staticRenderFns } from "./Report.vue?vue&type=template&id=536ac47f&scoped=true&"
import script from "./Report.vue?vue&type=script&lang=ts&"
export * from "./Report.vue?vue&type=script&lang=ts&"
import style0 from "./Report.vue?vue&type=style&index=0&id=536ac47f&prod&scoped=true&lang=css&"
import style1 from "./Report.vue?vue&type=style&index=1&id=536ac47f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536ac47f",
  null
  
)

export default component.exports